import {
  ActivityDay,
  ActivityIntention,
  ActivityMoment,
  ActivitySlot,
  SportGoal,
} from '../domains/activity-preferences';

export class LoadMyActivityPreferencesAction {
  static readonly type = '[ActivityPreferences] LoadMyActivityPreferencesAction';
}

export class SaveGeneralActivityPreferencesAction {
  static readonly type = '[ActivityPreferences] SaveGeneralActivityPreferencesAction';

  constructor(
    public payload: {
      availability?: ActivitySlot[];
      intention?: ActivityIntention;
    },
  ) {}
}

export class SaveSportActivityPreferencesAction {
  static readonly type = '[ActivityPreferences] SaveSportActivityPreferencesAction';

  constructor(
    public payload: {
      sportId: string;
      availability?: ActivitySlot[];
      intention?: ActivityIntention;
      goal?: SportGoal;
    },
  ) {}
}

/** Sends one sport back to the general answer, which is not emptying it. */
export class FollowGeneralForSportAction {
  static readonly type = '[ActivityPreferences] FollowGeneralForSportAction';

  constructor(public payload: { sportId: string }) {}
}

/** Ticks or unticks one cell of the grid being edited, before it is saved. */
export class ToggleAvailabilitySlotAction {
  static readonly type = '[ActivityPreferences] ToggleAvailabilitySlotAction';

  constructor(public payload: { day: ActivityDay; moment: ActivityMoment; sportId?: string }) {}
}
